// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"375":"reg-proyects","535":"login","871":"proyectos","944":"editar-proyect"}[chunkId] + "." + {"375":"8cfa5d37","535":"ab982d93","871":"ab19e9fa","944":"95befb78"}[chunkId] + ".css";
};